'use client'

import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@rr/ui'

/**
 * Placeholder shown for views that were deleted along with the
 * components/{ui,shadcn,platform}/ purge. Each call site needs to be
 * rebuilt against @rr/ui directly. Tracked in tasks/admin-ia-plan.md.
 */
export function RebuildNotice({
  title,
  hint,
}: {
  title: string
  hint?: string
}) {
  return (
    <Card className="my-4">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>
          Being rebuilt against <code className="font-mono">@rr/ui</code>. The
          old admin-local UI has been removed; this view will reappear once
          its primitives are wired to <code className="font-mono">@rr/ui</code>.
        </CardDescription>
      </CardHeader>
      {hint && (
        <CardContent>
          <p className="text-sm text-subtext">{hint}</p>
        </CardContent>
      )}
    </Card>
  )
}
